// @ts-nocheck

"use client";

import MuxPlayer from "@mux/mux-player-react";
import { useEffect, useState } from "react";

import { Video } from "@/sanity/sanity.types";
import { FC } from "react";

export type MuxVideoProps = {
  video: Video;
  backgroundSize?: string;
  fill?: boolean;
};

const MuxVideo: FC<MuxVideoProps> = ({
  video,
  backgroundSize,
  fill = false,
}) => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const { options } = video || {};

  const style = {
    "--controls": options?.controls ? "true" : "none",
    "--dialog": "none",
    "--loading-indicator": "none",
    "--play-button": "none",
    "--live-button": "none",
    "--seek-backward-button": "none",
    "--seek-forward-button": "none",
    "--mute-button": "none",
    "--captions-button": "none",
    "--airplay-button": "none",
    "--pip-button": "none",
    "--fullscreen-button": "none",
    "--cast-button": "none",
    "--playback-rate-button": "none",
    "--volume-range": "none",
    "--time-range": "none",
    "--time-display": "none",
    "--duration-display": "none",
    "--rendition-selectmenu": "none",
    "--center-controls": "none",
    "--bottom-play-button": "none",
    "--media-object-fit": fill ? "cover" : backgroundSize,
    "--media-object-position": backgroundSize,

    aspectRatio: fill
      ? undefined
      : backgroundSize === "contain"
        ? undefined
        : 1.8,
    minHeight: "100%",
    width: fill ? "100%" : undefined,
    height: fill ? "100%" : undefined,
    position: fill ? "absolute" : undefined,
    top: fill ? 0 : undefined,
    left: fill ? 0 : undefined,
  };

  if (!isMounted) {
    return null;
  }

  return (
    <MuxPlayer
      autoPlay={options?.autoPlay ?? true}
      loop={options?.loop ?? true}
      muted={options?.muted ?? true}
      maxResolution={options?.maxResolution ?? "2160p"}
      minResolution={options?.minResolution ?? "1440p"}
      style={style}
      playbackId={video?.video?.asset?.playbackId}
      metadata={{
        video_id: video?.video?.asset?.data?.id ?? "",
      }}
    />
  );
};

export default MuxVideo;
